export enum ApiError {
  OTP_SENT = 'OTP is already sent',
}
